'use client';

export interface WebinarRegistration {
  id: string;
  firstName: string;
  lastName: string;
  email: string;
  phone: string;
  webinarDate: string;
  webinarTime: string;
  webinarLink: string;
  registeredAt: string;
}

// Next scheduled webinar — every Tuesday at 7:00 PM ET
function getNextWebinarDate(): { date: string; time: string; link: string } {
  const now = new Date();
  const dayOfWeek = now.getDay(); // 0=Sun, 2=Tue
  const daysUntilTuesday = (2 - dayOfWeek + 7) % 7 || 7;
  const next = new Date(now);
  next.setDate(now.getDate() + daysUntilTuesday);
  next.setHours(19, 0, 0, 0);

  const dateStr = next.toLocaleDateString('en-US', {
    weekday: 'long',
    month: 'long',
    day: 'numeric',
    year: 'numeric',
  });

  return {
    date: dateStr,
    time: '7:00 PM ET',
    link: 'https://zoom.us/j/x39livetraining',
  };
}

export function getNextWebinar() {
  return getNextWebinarDate();
}

const STORAGE_KEY = 'webinar_registrations';

export function getWebinarRegistrations(): WebinarRegistration[] {
  if (typeof window === 'undefined') return [];
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    return raw ? JSON.parse(raw) : [];
  } catch {
    return [];
  }
}

export function saveWebinarRegistration(reg: Omit<WebinarRegistration, 'id' | 'registeredAt'>): WebinarRegistration {
  const registrations = getWebinarRegistrations();
  const newReg: WebinarRegistration = {
    ...reg,
    id: `wreg-${Date.now()}`,
    registeredAt: new Date().toLocaleString('en-US', {
      month: 'short',
      day: 'numeric',
      year: 'numeric',
      hour: 'numeric',
      minute: '2-digit',
      hour12: true,
    }),
  };
  registrations.push(newReg);
  if (typeof window !== 'undefined') {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(registrations));
  }
  return newReg;
}
